import { WIZ_EVENT_TYPE, VALUE_ENTER, VALUE_ESCAPE } from '@wizeoo/akm-core-lib';
import {
  FilterComponent,
  WizBasePopUp,
  WizDatasource,
  WizAgGrid,
  WizEventManager, WizEvent,
  WizAgGridUtils
} from '@wizeoo/akm-component-lib';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { FeiVO } from '../../../../../vo/workingdata/fei.vo';
import { FreedataValueVO } from  '../../../../../vo/core/freedatavalue.vo';
import { IWidget } from '../../../../../manager/widgets/i-widget';
import { PivotCellEditPopData } from '../../../../../manager/widgets/i-widget';
import { BaselineEngine, DataLoadObj, EM_ACTION, FeiKeyDef, FIELD_KIND, MeasureVO, VisionVO, WidgetLine, WizConstants } from '@wizeoo/akm-compute-lib';
import { Baseline, FormulaEngineInstance, VisionStep, WidgetConfigurationItemObj } from '@wizeoo/akm-message-lib';
import { ColDef } from 'ag-grid-community';
import { WizColDef } from '../../../../../manager/workingdata/fei.engine';
import { UpdateRequest } from '../../../../../command/core/sync/sync.service';
import { ViewData } from '../../../../../model/view.data';
import { ICellRendererParams } from '@ag-grid-community/core';
import { Pivot } from '../../pivot.component';


@Component({
  // popUp d'édition des cellules de type filterKey
  selector: 'pivot-cell-crosskey-edit-pop',
  templateUrl: './pivot-cell-crosskey-edit.pop.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PivotCellCrosskeyEditPop extends WizBasePopUp {

  @ViewChild('popFilter', { read: FilterComponent }) popFilter: FilterComponent; // filtre des mesures
  @ViewChild('agGrid') agGrid: WizAgGrid<FreedataValueVO>;


  // validation sur enter, sortie sur Esc
  @HostListener('window:keydown', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.key === VALUE_ENTER) {
      this.save();
    }
    if (event.key === VALUE_ESCAPE) {
      this.doCancel();
    }
  }

  /** accesseur avec cast */
  public get popupData(): PivotCellEditPopData {
    return this.datas as PivotCellEditPopData;
  }

  public columns: ColDef[]; // Colonnes du grid
  

  /** la DS de la liste. On recycle le mécanisme d'alimentation des filtres, il marche bien avec freedata et chrono */
  public mainDS: WizDatasource<Baseline> = new WizDatasource<Baseline>([])
    .setItemCodeField('key')
    .setFilter(this.filterFunc.bind(this))
    .setSelectionMode('single')
    .setSortFields([{ property: 'trsLabel', way: 'asc', numeric: false }])
    .build();

 
  public static baseWidth: number = 450;
  public static baseHeight: number = 300;

  public fei: FeiVO = null; // l'instance de FEI manipulée par ce composant
  public widget: IWidget; // accesseur sur le widget
  public line: WidgetLine; // la pl de référence pour update
  public pack: WidgetLine[]; // le pool de line effectif. Prise en compte de l'aggrégat en colonne
  private fkd: FeiKeyDef;

  public settings: any; // la conf de la mesure

  // lien vers la crossVision
  public crossVision: VisionVO;
  public crossFEI: FeiVO;

  // les valeurs de filtre pour cette ligne champCible sur le cross = [type(filter/ measure), valeur cherchée]
  public filterVal: Map<string, [string, string]> = new Map();

  constructor(public elementRef: ElementRef, protected cdref: ChangeDetectorRef) {
    super();
  }

  show(): void {
    // console.log('pivotCellCrossKey')
    this.widget = this.popupData.widget;
    this.fei = this.widget.fakeFei || this.widget.fei  as FeiVO;
    this.line = this.popupData.line;
    this.pack = this.popupData.pack;
    this.fkd = this.popupData.fkd;
    this.settings = this.fkd.measure.settings;

    this.feedDatasources();
    this.addListeners();
  }

  /** sur séquence de démarrage, alimentation des listes avec leurs DS */
  public feedDatasources(): void {
    
    // prise de la conf
    let vision: string = this.settings.vision;
    let level: number = this.settings.level;
    let scen: string = this.settings.scenario || WizConstants.BASE_SCENARIO;

    // on charge le dlo pour prendre ses lignes
    let dlo: DataLoadObj = this.widget.model.widgetDataService.getDataloadByKey(vision ,level, scen);
    let bls: Baseline[] = Object.values(dlo.localBaselines); 

    this.crossVision = this.widget.model.visionEngine.getVision(vision);
    const step: VisionStep = BaselineEngine.getVisionStepByLevel(this.crossVision, level);
    const fei: FormulaEngineInstance = new FormulaEngineInstance();
    fei.baselines = {};
    fei.vision = this.crossVision.source;
    fei.visionStep = step;
    this.crossFEI = new FeiVO(fei, this.widget.model, this.crossVision, step, ViewData.DEFAULT_SCENARIO);
    // construction de la map de clés du FEI
    BaselineEngine.buildKeys(this.crossFEI);

    this.settings.filters.forEach(f => {
      
      let crossKey: string = Object.keys(f)[0];
      let targetField: string = Object.values(f)[0] as string;
      let realValue: string = BaselineEngine.getRawKeyOrValue(this.fei, this.line, targetField);
      // console.log('filter', f,crossKey, targetField, realValue);
      let crossKeyField: FeiKeyDef = this.crossFEI.keyMap.get(crossKey);
      let crossKeyKind: string = null;
      if(!!crossKeyField) { // mauvais setting, la mesure n'existe pas
        crossKeyKind = crossKeyField.isFilterKey ? 'FILTER' : 'MEASURE';
        this.filterVal.set(crossKey, [crossKeyKind, realValue]);
      }
      
      
    });

    // console.log('this.filterVal',this.filterVal);

    // prise de la vision source pour obtenir les types

    this.columns = this.buildColumns(); // générer les colonnes depuis le contexte
    
    this.popFilter.configure([this.settings.key], null, null);
    
    // const edit: PivotFilterKeyItemObj[] = allowedFdvs.map((fd: FreedataValueVO) => new PivotFilterKeyItemObj(fd));
    this.mainDS.setSource(bls);

    let rawValue: string = this.popupData.value; // valeur active

    let selected: Baseline = this.mainDS.getItemByKey(rawValue);
    if(!!selected) {
      this.mainDS.select([selected]);
      this.agGrid.api.ensureIndexVisible(this.mainDS.getItemIndex(selected[0]));
    }

  }

  /** mise en place des écouteurs */
  public addListeners(): void {
    WizEventManager.addListener(this, this.agGrid, WIZ_EVENT_TYPE.SELECTION_CHANGED, this.innerSelectionChange);
    WizEventManager.addListener(this, this.popFilter, WIZ_EVENT_TYPE.FILTER, this.doFilter); // ecouteur sur le filtre des mesures & function
  }

  // filterFunc de la collection de bls
  protected filterFunc(item: Baseline): boolean {
    
    // TODO jouer les filtres globaux, compo & user
    let result: boolean = true;

    [...this.filterVal.keys()].forEach(k => {
      let pair: string[] = this.filterVal.get(k);
      let kind: string = pair[0];
      let target: string = pair[1];

      let itemVal: string = null;
      if(kind === 'FILTER') {
        itemVal = item.fkeyjson[k];
      } else { // mesure
        try {
          itemVal = item.values[k]?.valor;
        } catch(e: any) {
          // si aucune mesure sur la BL, ou pas la valeur
        }
        
      }

      // console.log('filterFunc', itemVal, kind, target);
      if(itemVal !== target) {
        result = false;
        return;
      }

    });

    if(!result) {
      return false;
    }

    return this.popFilter.checkVisible(item);
  }

  /**
   * modification du filtre des fdv
   * @param e WizEvent
   */
  protected doFilter(e: WizEvent): void {
    this.mainDS.refresh();
  }

  /**
   * Synchronisation du selected
   * @param pEvent wizEvent contenant l'item sélectionné
   */
  private innerSelectionChange(pEvent: WizEvent): void {

  }

  /** Sauvegarde, même valeur */
  public save(): void {
    let value: string = '';
    if (this.mainDS.selectedItem) {
      value = this.mainDS.selectedItem.key;
    }

    const updates: UpdateRequest = {
      fei: this.fei, 
      line: this.line,
      lines: this.pack, 
      operation: EM_ACTION.UPDATE,
      fkd: this.fkd,
      value,
      doSplit: false
    };

    this.popupData.updates = updates;
    this.popupData.callback(this.popupData); // on appelle la callback avec le pack d'updates

    this.hide();
  }

  /** annulation des modifs */
  public doCancel(): void {
    // this.doSaveFlag = false;
    this.hide();
  }

  public hide() {
    WizEventManager.removeListener(this, this.agGrid, WIZ_EVENT_TYPE.SELECTION_CHANGED);
    WizEventManager.removeListener(this, this.popFilter, WIZ_EVENT_TYPE.FILTER);
    super.hide();
  }

  /** construction des colonnes */
  private buildColumns(): WizColDef[] {
    const cols: WizColDef[] = [];

    let rawCols: any[] = this.settings.columns;
    // console.log('columns', rawCols);
    // let keyDefs: FeiKeyDef[] = [];

    // enrichissement des colonnes
    rawCols.forEach(rc => {
      let kd: FeiKeyDef = this.crossFEI.keyMap.get(rc.field);
      
        rc['fkd'] = kd; 
        let label: string = rc.label || null;
        
      if(!!kd) { // mauvaise mesure pour le rendu
        if(rc.fkd.isFilterKey && !rc.fkd.isKey) { // filter
          if(!label) {
            label = rc.fkd.fullCode; // TODO prise du arg si existe
          }
          rc.kind = 'FILTER';
        } else if(rc.fkd.isKey) {
          if(!label) {
            label = rc.fkd.fullCode; // TODO prise du arg si existe
          }
          rc.kind = 'KEY';
        } else {
          let fakeMVO: MeasureVO = new MeasureVO(rc.fkd.measure);
          if(!label) {
            label = fakeMVO.trsLabel;
          } 
          rc.kind = 'MEASURE';
        }
      }

      rc.label = label;
    });


    rawCols.forEach(rc => {
      if(!!rc.fkd) {
        let coldef: any = { headerName: rc.label, width: 100, sortable: true, resizable: true, field: rc.fkd.fullCode, conf: rc };
        coldef.fkd = rc.fkd;
        coldef.widget = this.widget;
        coldef.valueGetter = this.valueAccessor.bind(this);
        coldef.valueFormatter = this.valueFormatter.bind(this);

        let dataType: string = FIELD_KIND.STRING;
        if(rc.kind === 'KEY' || rc.kind === 'FILTERKEY') {
          // console.log("prise du type sur le arg selon sub");
          // prise du arg
          if(rc.sub) {
          rc.arg = this.widget.model.freedataEngine.getArgFromFD(rc.field.split(WizConstants.CONTEXT_SEPARATOR)[0], rc.sub);
          // console.log("prise du type sur le arg selon sub", rc.sub, rc.arg);
          if(!!rc.arg) {
            dataType = rc.arg.dataType;
          } 
          }
        } else {
          if(!!rc.fkd.measure.dataKind) {
            dataType = rc.fkd.measure.dataKind;
          }
          
        }

        // console.log('datakind', dataType);
          if (dataType === FIELD_KIND.BINARY) {
            coldef.cellClass = 'grid-cell-centered';
            coldef.cellRenderer = this.widget.model.gridAccessors.attachmentCellRender;
            // coldef.valueFormatter = this.voidFormatter;
            coldef.tooltipField = null;
          } else if (dataType === FIELD_KIND.BINARY_MULTI) {
            coldef.cellClass = 'grid-cell-centered';
            coldef.cellRenderer = this.widget.model.gridAccessors.attachmentMultiCellRender;
            // coldef.valueFormatter = this.voidFormatter;
            coldef.tooltipField = null;
          } else if (dataType === FIELD_KIND.BOOLEAN) {
            coldef.cellClass = 'cbox-cell';
            coldef.cellClass += ' no-edit';
            // coldef.valueFormatter = this.voidFormatter;
            coldef.cellRenderer = WizAgGridUtils.CELL_CHECKBOX_RENDERER;
          } 

        // TODO type de rendu comme PivotCellFilterkeyEditPop
        cols.push(coldef);
      }
    });
    
    return cols;  
  }


  public askForUnselect(): void {
    this.mainDS.clearSelection();
    // console.log('askForUnselect');
  }

  public valueAccessor(params: ICellRendererParams): string {
   let conf: any = (params.colDef as any).conf;
   let result: string = null;
   
   switch(conf.kind) {
    case "KEY": // TODO prévoir le split
      result = params.data.key;
      if(conf.arg) { // autre champ
        if(result) {
          let fdv: FreedataValueVO = this.widget.model.freedataEngine.getFreedataValue(conf.arg.freeDataCode, result);
          if(!!fdv) {
             result = this.widget.model.freedataEngine.getFDValue(fdv, conf.arg.code);
          }
        }
      }
      break;
    case "FILTER":
      result = params.data.fkeyjson[conf.field];
      if(conf.arg) { // autre champ
        if(result) {
          let fdv: FreedataValueVO = this.widget.model.freedataEngine.getFreedataValue(conf.arg.freeDataCode, result);
          if(!!fdv) {
             result = this.widget.model.freedataEngine.getFDValue(fdv, conf.arg.code);
          }
        }
      }
      break;
    case "MEASURE":
      result = params.data.values[conf.field]?.valor || null;
      break;
   }
   



   // console.log('valueAccessor', (params.colDef as any).conf, params.value, result);
   return result;
  }


  public valueFormatter(params: any): string {
   // console.log('valueFormatter', (params.colDef as any).conf, params.value);
   let conf: any = (params.colDef as any).conf;
   let fkd: FeiKeyDef = conf.fkd;
   let result: string = null;
    
    // interception LIST 
    if(fkd.datakind === FIELD_KIND.LIST) { 
      return (this.widget as Pivot).patchListFormatter(params);
    } 
    // interception THRESHOLD 
    else if(fkd.datakind === FIELD_KIND.THRESHOLD) { 
      return (this.widget as Pivot).patchThresholdFormatter(params);
    } 
    // interception FILTER 
    else if(fkd.datakind === FIELD_KIND.FILTER) { 
      return (this.widget as Pivot).patchFilterFormatter(params);
    } 
    // interception Workflow 
    else if(fkd.datakind === FIELD_KIND.WORKFLOW) { 
      // console.log('datakind WORKFLOW', params.colDef?.wcio?.fdvf);
      return this.widget.model.workflowEngine.valueFormatter(params);
    }   

    // prise du format sur le FKD, le colDef.datakind est possiblement un aggrégat d'un autre type
    let datakind: string = fkd.datakind;
    let format: string = fkd.defaultFormat;
    result = this.widget.model.formatEngine.applyFormat(params.value, datakind, format, null);   
    // console.log('valueFormatter', line.key, line.isTotalLine, line.isSubTotalLine,params.colDef, params.value,  result);
    return result;

  }

}


